export const SUPPORT_EMAIL = 'support@yoga-go.io';
export const YOGA_CABINET_LINK = 'app.yoga-go.io';
